module.exports = __webpack_public_path__ + "hero.png?3bd8739cfa71c03f0fa7e0c91e7c0165";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero.png
// module id = 174
// module chunks = 0